import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { memo, useState, useEffect } from 'react';

interface LottieAnimationProps {
  src: string;
  loop?: boolean;
  autoplay?: boolean;
  className?: string;
  speed?: number;
  ariaLabel?: string;
  onComplete?: () => void;
}

function LottieAnimation({
  src,
  loop = true,
  autoplay = true,
  className = '',
  speed = 1.0,
  ariaLabel,
}: LottieAnimationProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return (
      <div className={className} role="img" aria-label={ariaLabel || 'Animation'}>
        <div className="w-full h-full bg-brand-dark/10 rounded" />
      </div>
    );
  }

  return (
    <div className={className} role="img" aria-label={ariaLabel || 'Animation'}>
      <DotLottieReact
        src={src}
        loop={loop}
        autoplay={autoplay}
        speed={speed}
        useFrameInterpolation={true}
      />
    </div>
  );
}

export default memo(LottieAnimation);
